import { render, staticRenderFns } from "./p01.vue?vue&type=template&id=792fffeb&scoped=true&"
import script from "./p01.vue?vue&type=script&lang=js&"
export * from "./p01.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792fffeb",
  null
  
)

export default component.exports